import { CardType } from 'types/deck'

import { useAppSelector } from 'redux/hooks'
import { DeckState } from 'redux/deck/initialState'
import { selectFilteredStacks, selectStacks } from 'redux/deck/selectors'

import DeckDetailsFetchingOverlayWrapper from 'components/folderPage/DeckDetailsFetchingOverlayWrapper'
import DeckHeader from 'components/deckPage/header/DeckHeader'
import BasicCard from 'components/card/BasicCard'

import styles from './deckPreviewOverlay.module.scss'

type Props = {
  deckId: string | number
  open: boolean
  onClose: () => void
  initialDeckState?: Partial<DeckState>
  manualFilterData?: (card: CardType) => boolean
  showQuantity?: boolean
}

const DeckPreviewOverlay = ({ deckId, open, onClose, initialDeckState, manualFilterData, showQuantity }: Props) => {
  const { mainDeck, sideDeck } = useAppSelector(state =>
    manualFilterData ? selectFilteredStacks(state, manualFilterData) : selectStacks(state),
  )

  const allStacks = [...mainDeck, ...sideDeck]
  const cardTotal = allStacks.reduce((acc, stack) => acc + stack.quantity, 0)

  return (
    <DeckDetailsFetchingOverlayWrapper
      open={open}
      onClose={onClose}
      deckId={deckId}
      initialDeckState={initialDeckState}>
      <div className={styles.content}>
        <DeckHeader className={styles.headerContainer} containerClassName={styles.header} hideControls />

        {showQuantity && <h2>{cardTotal} total cards</h2>}

        <div className={styles.cards}>
          {allStacks.map(stack => (
            <div key={stack.name}>
              <h3>{stack.name}</h3>
              <div className={styles.grid}>
                {stack.cardIds.map(cardId => (
                  <Card cardId={cardId} key={cardId} />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </DeckDetailsFetchingOverlayWrapper>
  )
}

export default DeckPreviewOverlay

const Card = ({ cardId }: { cardId: string }) => {
  const card = useAppSelector(state => state.deck.cardMap[cardId])

  return <BasicCard card={card} className={styles.basicCard} includeColorTag />
}
